import React from 'react';
import { QrIcon } from '../../components/ui/icons';
import JoinPanel from '../../components/JoinPanel';
import './EmptyState.css';

/**
 * Shown at `/` when this device has no crawl on the go. The dashed pump clip
 * is deliberately the same shape as the filled one on the main screen — the
 * shape people see waiting is the shape that fills up with their time.
 */
const EmptyState: React.FC = () => (
  <div className="empty-state" data-testid="empty-state">
    <div className="empty-state-hero">
      <div className="pump-clip pump-clip-waiting">
        <QrIcon size={72} />
      </div>
      <h1 className="empty-state-title">Nothing on the go</h1>
      <p className="empty-state-body">
        Find a Scan·Drink·Race QR code in any participating pub. Scanning it starts your
        clock and picks the crawl for you.
      </p>
    </div>

    <div className="empty-state-divider">Or</div>

    <div className="empty-state-join">
      <JoinPanel />
    </div>
  </div>
);

export default EmptyState;
